import {
  Badge,
  Stack,
  ViewHeader,
  ViewItemField,
  ViewItemFieldWithChildren,
} from '@fukuri-admins/ui/common';

type Props = {
  /** 契約プラン名（タイトルとして表示する） */
  title: string;
  /** 種別バッジ */
  kindBadge: {
    /** 表示ラベル */
    label: string;
    /** バッジステータス */
    status: 'neutral' | 'info';
  };
  /** 紐づくギフトプラン（フォーマット済み） */
  giftPlan: string;
  /** 顧客請求単価（フォーマット済み） */
  customerChargeUnitPrice: string;
  /** 税率（フォーマット済み） */
  taxRatePercent: string;
  /** 作成日時（フォーマット済み） */
  createdAt: string;
  /** 更新日時（フォーマット済み） */
  updatedAt: string;
};

/**
 * 契約プラン詳細 Presentation
 *
 * - タイトル（プラン名）を ViewHeader で表示する
 * - 各項目をラベル幅 172px + 値で表示する
 * - 種別は Badge コンポーネントで表示する
 * - 編集 UI はなし（read-only）
 * - パンくずリストは Screen（ContractPlanDetailScreenContent）で PageHeader として表示する
 */
export const ContractPlanDetailPresentation: React.FC<Props> = ({
  title,
  kindBadge,
  giftPlan,
  customerChargeUnitPrice,
  taxRatePercent,
  createdAt,
  updatedAt,
}) => (
  <Stack direction='column' gap={24} height='inherit'>
    <ViewHeader title={title} />
    <Stack direction='column' gap={24}>
      <ViewItemFieldWithChildren label='種別' direction='row'>
        <Badge status={kindBadge.status} variant='outline' size='sm' label={kindBadge.label} />
      </ViewItemFieldWithChildren>
      <ViewItemField label='紐づくギフトプラン' direction='row' value={giftPlan} />
      <ViewItemField label='顧客請求単価' direction='row' value={customerChargeUnitPrice} />
      <ViewItemField label='税率' direction='row' value={taxRatePercent} />
      <ViewItemField label='作成日時' direction='row' value={createdAt} />
      <ViewItemField label='更新日時' direction='row' value={updatedAt} />
    </Stack>
  </Stack>
);
